import AdminUserListPage from "@/features/system-settings/pages/AdminUserList";
import { AdminUserListFilterCacheProvider } from "@/features/system-settings/providers/AdminUserListFilterCacheProvider";

const AdminUserList = () => {
  return (
    <AdminUserListFilterCacheProvider>
      <AdminUserListPage />
    </AdminUserListFilterCacheProvider>
  );
};
export default AdminUserList;
